module.exports = __webpack_public_path__ + "static/media/pan2Wrong.d69f6c9b.png";